<template>
  <ul class="operate">
    <li @click="itemClickHanlder">
      <div class="lawyer">
        <img class="avatar" :src="data.avatar" alt="" />
        <div class="lawyer-info">
          <p class="lawyer-info-name">{{ data.name }}</p>
          <p class="lawyer-info-address">律师事务所：{{ data.deptName }}</p>
          <p class="lawyer-info-number">执业证号：{{ data.licenseNo }}</p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'lawyerItem',
    props: {
      data: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {}
    },
    methods: {
      itemClickHanlder() {
        if (this.data.delFlag) {
          this.$toast('该信息已被管理员删除')
          return
        }
        this.$router.push({ path: '/legal/lawyer-details', query: { id: this.data.id } })
      }
    }
  }
</script>

<style scoped lang="scss">
  .operate {
    /*display: flex;*/
    /*align-items: center;*/
    li {
      display: flex;
      justify-content: space-between;
    }

    .icon {
      width: 14px;
      height: 14px;
      margin-right: 12px;
    }

    .lawyer {
      width: 351px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      margin-top: 12px;
      padding: 16px 12px;

      .avatar {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }

      &-info {
        margin-left: 16px;

        &-name {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 26px;
        }

        &-address,
        &-number {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
        }

        &-address {
          max-width: 180px;
          margin-top: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
</style>
